import {DownloadOutlined, SearchOutlined} from "@ant-design/icons";
import {Tooltip} from "antd";
import {DownloadButton} from "components/_defaultComponents/DownloadButton/DownloadButton";
import {VFlex} from "components/_defaultComponents/Flex/VFlex";
import {useStore} from "hooks/useStore";
import React from "react";
import SearchInput from "./SearchInput.js";
import {CustomButton} from "components/_defaultComponents/CustomButton/CustomButton.js";

const ActionButtons = ({
    loadingExcelData,
    handleDownloadExcel,
    loadingExcelDataV2,
    handleDownloadExcelV2,
    onSearch
}) => {
    const stores = useStore();
    return (
        <VFlex vertical minWidth={200} align="flex-end" marginBottom={"16px"}>
            <VFlex gap={10} wrap justify="flex-end" fullWidth>
                <SearchInput
                    tooltip="Kurye İsim ve TCKN, Sipariş No ile arama yapabilirsiniz."
                    placeholder="Kurye İsim ve TCKN, Sipariş No ile arama yapabilirsiniz."
                    onSearch={onSearch}
                    enterButton={
                        <CustomButton
                            data-testid="searchInput_searchButton"
                            icon={<SearchOutlined />}
                            style={{marginRight: "0px", marginTop: "0px"}}
                        />
                    }
                />
                {!stores.meStore.checkRole("isAgency") && (
                    <Tooltip title={"Excel Çıktısı İndir"}>
                        <DownloadButton
                            type="primary"
                            icon={<DownloadOutlined spin={stores.appStore.loading} />}
                            data-testid="downloadButton"
                            loading={loadingExcelData}
                            onClick={handleDownloadExcel}
                            marginTop={"0px"}
                        >
                            İndir
                        </DownloadButton>
                    </Tooltip>
                )}
                {stores.meStore.checkPermission("creditLogs.export") && (
                    <Tooltip title={"Excel Çıktısı İndir"}>
                        <DownloadButton
                            type="primary"
                            icon={<DownloadOutlined spin={stores.appStore.loading} />}
                            data-testid="downloadButton"
                            loading={loadingExcelDataV2}
                            onClick={handleDownloadExcelV2}
                            marginTop={"0px"}
                        >
                            İndir V2
                        </DownloadButton>
                    </Tooltip>
                )}
            </VFlex>
        </VFlex>
    );
};

export default ActionButtons;
